module.exports = __webpack_public_path__ + "img/lastName.edaec4a6.svg";